export default __webpack_public_path__ + "static/media/landingpageiconleftbg2.097581e7.png";